export default "__VITE_ASSET__BEe1CDlh__"